import { REDUCER } from './reducersConst';
import { DISCUSSION_MESSAGES_ORDER_OBJECT } from '../const';

let defaultDiscussionsState = {
  currentDiscussions: { pages: 1, currentPage: 0, discussions: [], fetching: false },
  finishedDiscussions: { pages: 1, currentPage: 0, discussions: [], fetching: false },
  futureDiscussions: { pages: 1, currentPage: 0, discussions: [], fetching: false },
  selectedDiscussion: {
    discussion: {},
    messages: {
      list: [],
      fetching: false,
      messagesOrder: DISCUSSION_MESSAGES_ORDER_OBJECT.OLDER_FIRST,
      pages: 1,
      currentPage: 0
    },
    fetching: false
  },
  activeDiscussionTab: undefined,
  removeReveal: {
    isOpen: false,
    discussion: {}
  },
  closeReveal: {
    isOpen: false,
    discussion: {}
  }
};

export let discussions = (state = defaultDiscussionsState, action) => {
  switch (action.type) {
    case REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS:
      return {
        ...state,
        currentDiscussions: Object.assign({}, state.currentDiscussions, { discussions: action.discussions })
      };
    case REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_PAGES:
      return {
        ...state,
        currentDiscussions: Object.assign({}, state.currentDiscussions, { pages: action.pages })
      };
    case REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_CURRENT_PAGE:
      return {
        ...state,
        currentDiscussions: Object.assign({}, state.currentDiscussions, { currentPage: action.currentPage })
      };
    case REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_FETCHING:
      return {
        ...state,
        currentDiscussions: Object.assign({}, state.currentDiscussions, { fetching: action.fetching })
      };
    case REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS:
      return {
        ...state,
        finishedDiscussions: Object.assign({}, state.finishedDiscussions, { discussions: action.discussions })
      };
    case REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_PAGES:
      return {
        ...state,
        finishedDiscussions: Object.assign({}, state.finishedDiscussions, { pages: action.pages })
      };
    case REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_CURRENT_PAGE:
      return {
        ...state,
        finishedDiscussions: Object.assign({}, state.finishedDiscussions, { currentPage: action.currentPage })
      };
    case REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_FETCHING:
      return {
        ...state,
        finishedDiscussions: Object.assign({}, state.finishedDiscussions, { fetching: action.fetching })
      };
    case REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS:
      return {
        ...state,
        futureDiscussions: Object.assign({}, state.futureDiscussions, { discussions: action.discussions })
      };
    case REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_PAGES:
      return {
        ...state,
        futureDiscussions: Object.assign({}, state.futureDiscussions, { pages: action.pages })
      };
    case REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_CURRENT_PAGE:
      return {
        ...state,
        futureDiscussions: Object.assign({}, state.futureDiscussions, { currentPage: action.currentPage })
      };
    case REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_FETCHING:
      return {
        ...state,
        futureDiscussions: Object.assign({}, state.futureDiscussions, { fetching: action.fetching })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, { discussion: action.discussion })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_FETCHING:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, { fetching: action.fetching })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, {
          messages: { ...state.selectedDiscussion.messages, list: action.messages }
        })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_FETCHING:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, {
          messages: { ...state.selectedDiscussion.messages, fetching: action.fetching }
        })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_ORDER:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, {
          messages: { ...state.selectedDiscussion.messages, messagesOrder: action.messagesOrder }
        })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_PAGES:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, {
          messages: { ...state.selectedDiscussion.messages, pages: action.pages }
        })
      };
    case REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_CURRENT_PAGE:
      return {
        ...state,
        selectedDiscussion: Object.assign({}, state.selectedDiscussion, {
          messages: { ...state.selectedDiscussion.messages, currentPage: action.currentPage }
        })
      };
    case REDUCER.DISCUSSION.SET_ACTIVE_TAB:
      return {
        ...state,
        activeDiscussionTab: action.activeDiscussionTab
      };
    case REDUCER.DISCUSSION.SET_REMOVE_MODAL_OPEN:
      return {
        ...state,
        removeReveal: Object.assign({}, state.removeReveal, { isOpen: action.removeDiscussionRevealIsOpen })
      };
    case REDUCER.DISCUSSION.SET_REMOVE_MODAL_DATA:
      return {
        ...state,
        removeReveal: Object.assign({}, state.removeReveal, { discussion: action.discussion })
      };
    case REDUCER.DISCUSSION.SET_CLOSE_MODAL_OPEN:
      return {
        ...state,
        closeReveal: Object.assign({}, state.closeReveal, { isOpen: action.closeDiscussionRevealIsOpen })
      };
    case REDUCER.DISCUSSION.SET_CLOSE_MODAL_DATA:
      return {
        ...state,
        closeReveal: Object.assign({}, state.closeReveal, { discussion: action.discussion })
      };
    default:
      return state;
  }
};
